import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { ADOBE_TAGS, AdobeService, MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { PurchaseMethodsV25, CurrencyFormats } from '@sm360/widget-commons-vehicle';

import CalculatorRebatesTradeIn from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorRebatesTradeIn/CalculatorRebatesTradeIn.jsx';

import 'payment-calculator-v25/components/PaymentBar/PaymentBar.scss';

class PaymentBar extends React.Component {
    constructor(props) {
        super(props);

        this.handlePaymentCalculator = this.handlePaymentCalculator.bind(this);
    }

    handlePaymentCalculator() {
        if (this.props.hasAdobeTagging && !this.props.frequenciesPanelOpen) {
            AdobeService.eventTrigger(
                ADOBE_TAGS.VDP_ACTIONS(
                    this.props.quote?.vehicle?.vehicleCondition,
                    'payment calculator',
                    {
                        make: this.props.quote?.vehicle?.make?.name,
                        model: this.props.quote?.vehicle?.model?.name,
                    },
                    this.props.vehicle?.commercialVehicle
                ),
                'global-onclick'
            );
        }
        this.props.setMobilePaymentCalculatorOpened(true);
    }

    render() {
        const prices = this.props.purchaseMethods.getSelectedPurchaseMethodPaymentOption();
        // Finance pricing
        const creditRate = prices?.term?.aprDetails?.creditRate;
        const apr = !this.props.displayCreditRate || !creditRate ? prices?.term?.apr || 0 : creditRate;
        const cashDown = prices?.cashDown ? LocaleService.l(prices.cashDown, CurrencyFormats.CURRENCY_0) : '';
        const months = prices?.term?.term
            ? `/${prices.term.term} ${LocaleService.t('PAYMENT_CALCULATOR_V25.TERMLABELS.MONTHS')}`
            : '';

        const taxCodes = this.props.taxCodes || LocaleService.t('taxes.taxes');
        const taxesDisclaimer = prices?.taxesDisclaimer;

        const payment = prices?.term?.payment ? LocaleService.l(prices.term.payment, CurrencyFormats.CURRENCY_2) : '';
        const paymentTaxes = prices?.term?.paymentTaxes
            ? LocaleService.l(prices.term.paymentTaxes, CurrencyFormats.CURRENCY_2)
            : '';
        const totalPayment = prices?.term?.totalPayment
            ? LocaleService.l(prices.term.totalPayment, CurrencyFormats.CURRENCY_2)
            : '';

        const paymentTaxesDisclaimer = ` + ${paymentTaxes} (${taxCodes}) = ${totalPayment}`;

        const purchaseMethodLabels = this.props.purchaseMethods.getPurchaseMethodLabels(LocaleService);

        const calculatedPaymentSplit = payment
            ? PurchaseMethodsV25.PurchaseMethodsService.getFormattedCurrencySplit(payment)
            : '';

        const rate = (
            <div className="paymentCalculator__interests">
                <span className="paymentCalculator__interests--amount">
                    {apr.toFixed(2).split('.')[0]}
                    <sup>
                        {apr.toFixed(2).split('.')[1]}% {this.props.displayCreditRate && 'APR'}
                    </sup>
                </span>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                    <span className="paymentCalculator__interests--duration sr-mediumColor">{months}</span>
                </MediaQuery>
            </div>
        );

        // Common pricing
        const navCashdown = !!cashDown && (
            <div className="paymentCalculator__cashdown-amount">
                {cashDown}
                <span>{LocaleService.t('PAYMENT_CALCULATOR_V25.TERMLABELS.CASHDOWN')}</span>
            </div>
        );

        const setPaymentLabel = !this.props.frequenciesPanelOpen
            ? 'PAYMENT_CALCULATOR_V25.SET_PAYMENT'
            : 'PAYMENT_CALCULATOR_V25.SAVE_PAYMENT';
        const iconPanel = !this.props.frequenciesPanelOpen ? 'icon-calculatrice' : 'icon-X-rouge';

        const paymentInfos = !this.props.purchaseMethods.isCashPurchase() ? (
            <div className="paymentCalculator__paymentsInfos">
                <div className="paymentCalculator__title">
                    <span className="is-bold">{purchaseMethodLabels.verb}</span>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                        <span className="paymentCalculator__title--note is-light">
                            ({this.props.paymentFrequencyLabels.periodically})
                        </span>
                    </MediaQuery>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <span className="paymentCalculator__title--note is-light">{months}</span>
                    </MediaQuery>
                </div>
                <div>
                    <div className="paymentCalculator__paymentsWrapper">
                        <div className="paymentCalculator__payment">
                            <span className="is-util is-bold">{calculatedPaymentSplit.beforeDecimal}</span>
                            <sup className="is-util">{calculatedPaymentSplit.afterDecimal}</sup>
                            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                <span className="paymentCalculator__title--note">
                                    ({this.props.paymentFrequencyLabels.periodically})
                                </span>
                            </MediaQuery>
                            <span className="paymentCalculator__payment--details is-light">
                                {paymentTaxesDisclaimer}
                            </span>
                        </div>
                        {rate}
                        {navCashdown}
                        {prices?.tradeIn > 0 &&
                            !this.props.purchaseMethods.isCashPurchase() && (
                                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                                    <div className="paymentCalculator__tradeIn--term" onClick={this.showTradeInLabel}>
                                        <span>
                                            {LocaleService.t(
                                                'PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.TRADEIN_MOBILE'
                                            )}
                                        </span>
                                        {LocaleService.l(prices.tradeIn, CurrencyFormats.CURRENCY_0)}
                                    </div>
                                </MediaQuery>
                            )}
                    </div>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                        <div />
                        <CalculatorRebatesTradeIn purchaseMethods={this.props.purchaseMethods} />
                    </MediaQuery>
                </div>
            </div>
        ) : (
            <div className="paymentCalculator__paymentsInfos">
                <div className="paymentCalculator__title is-bold">
                    {LocaleService.t('PAYMENT_CALCULATOR_V25.CALCULATOR_REBATES_TRADEIN.SELLING_PRICE')}
                </div>
                <div>
                    <div className="paymentCalculator__paymentsWrapper">
                        <div className="paymentCalculator__payment">
                            <span className="is-util">
                                {prices?.sellingPrice
                                    ? LocaleService.l(prices.sellingPrice, CurrencyFormats.CURRENCY_0)
                                    : LocaleService.t('NOT_AVAILABLE')}
                            </span>
                            <span className="paymentCalculator__payment--details sr-mediumColor">
                                {taxesDisclaimer}
                            </span>
                        </div>
                    </div>
                    <CalculatorRebatesTradeIn purchaseMethods={this.props.purchaseMethods} />
                </div>
            </div>
        );

        return (
            <div>
                <div className="sr-paymentCalculator-background">
                    <section className="paymentCalculator__wrapper">
                        {paymentInfos}
                        <div className="paymentCalculator__buttons">
                            <button
                                id="calculator-toggle-button"
                                className="sr-button-1 is-fluid"
                                onClick={this.handlePaymentCalculator}
                                aria-label={LocaleService.t(setPaymentLabel)}
                            >
                                <icon id="open-calculator" className={iconPanel} />
                                <span>{LocaleService.t(setPaymentLabel)}</span>
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

PaymentBar.propTypes = {
    setMobilePaymentCalculatorOpened: PropTypes.func.isRequired,
    paymentFrequencyLabels: PropTypes.shape({
        periodically: PropTypes.string.isRequired,
    }),
    frequenciesPanelOpen: PropTypes.bool.isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    displayCreditRate: PropTypes.bool,
    hasAdobeTagging: PropTypes.bool,
};

PaymentBar.defaultProps = {
    paymentFrequencyLabels: [],
    displayCreditRate: false,
    hasAdobeTagging: false,
};

PaymentBar.displayName = 'PaymentBar';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethodsV25,
        quote: state.quoteV25,
    };
}

export default connect(mapStateToProps)(PaymentBar);
export { PaymentBar };
